import React, {useEffect, useState} from 'react';
import {HtmlParse} from 'utils';
import primeLogo from 'images/prime/jumbo-prime-icon.svg'
import pinkIcon from 'images/prime/prime-icon-pink.svg'
import benefics from 'components/Drawers/benefics';
import dayjs from 'dayjs';
import PrimeService from 'services/Prime';
import style from './style.scss';

const InformationText = () => {
    const [endDate, setEndDate] = useState(false);

    const getStatusPrime = () => {
        return PrimeService.getSuscription().then(res => {
            if (res?.data?.data?.status && dayjs(res?.data?.data?.benefit_end_date).format() > dayjs().format()) {
                const endDate = dayjs(res?.data?.data?.benefit_end_date).add(6, 'month').format('DD/MM/YYYY');
                return (endDate);
            } else {
                return(false);
            }
        })
    }

    useEffect(() => {
        getStatusPrime().then((response) => {
            if(response) {
                setEndDate(response);
            } else {
                setEndDate(dayjs().add(6, 'month').format('DD/MM/YYYY'));
            }
        })
    }, []);

    return (
        <div className={'drawer-container'}>
            <h1 className="drawer-title">¡Felicidades! Ya eres Jumbo Prime</h1>

            <div className={'drawer-scroll drawer-welcome-prime-content'}>
                <div className="welcome-prime-logo">{HtmlParse(primeLogo)}</div>

                <div className="welcome-prime-info-wrap">
                    <div className="welcome-prime-info">
                        <div className="welcome-prime-info-right">
                            <div className="welcome-prime-info-right-text-wrap">
                                <span className="welcome-prime-info-right-text-title">6 meses</span>
                                <span className="welcome-prime-info-right-text-subtitle">$25.000</span>
                            </div>

                            <div className="welcome-prime-info-right-icon-wrap">
                                <i>{HtmlParse(pinkIcon)}</i>
                            </div>
                        </div>

                        <div className="welcome-prime-info-left">
                            <div className="welcome-prime-info-left-text">Aprovecha tu suscripción hasta el <span className="welcome-prime-info-left-date">{endDate}</span></div>
                        </div>
                    </div>
                </div>

                <div className="welcome-prime-benefics-wrap">
                    <span className="welcome-prime-benefics-title">Disfruta tus beneficios</span>

                    <ul className="welcome-prime-benefics-list-wrap">
                        {benefics && benefics.map((item, i) => {
                            return (
                                <li className="welcome-prime-benefics-list-item" key={i}>
                                    <i className="welcome-prime-benefics-list-icon">•</i>

                                    <div className="welcome-prime-benefics-list-text-wrap">
                                        <span className="welcome-prime-benefics-list-title">{item.title}</span>
                                        <span className="welcome-prime-benefics-list-subtitle">{HtmlParse(item.subtitle)}</span>
                                        {item.menssage && <span className="welcome-prime-benefics-list-menssage">{item.menssage}</span>}
                                    </div>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default InformationText;